import { render, staticRenderFns } from "./LossSeverity.vue?vue&type=template&id=2ad25df4&scoped=true&"
import script from "./LossSeverity.vue?vue&type=script&lang=js&"
export * from "./LossSeverity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad25df4",
  null
  
)

export default component.exports